export default __webpack_public_path__ + "static/media/register_specimens.5c25d138.gif";